// NotificationProvider.tsx
import React, { createContext, ReactNode, useContext } from 'react';
import { App } from 'antd';

export type NotificationType = 'success' | 'info' | 'warning' | 'error';

interface NotificationContextProps {
	openNotificationWithIcon: (
		type: NotificationType,
		message: string,
		description?: string
	) => void;
}

const NotificationContext = createContext<NotificationContextProps | undefined>(
	undefined
);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const { notification } = App.useApp();

	const openNotificationWithIcon = (
		type: NotificationType,
		message: string,
		description = ''
	) => {
		notification[type]({
			message,
			description: <span aria-label={message}>{description}</span>,
		});
	};

	return (
		<NotificationContext.Provider value={{ openNotificationWithIcon }}>
			{children}
		</NotificationContext.Provider>
	);
};

export const useNotification = () => {
	const context = useContext(NotificationContext);
	if (!context) {
		throw new Error('useNotification must be used within a NotificationProvider');
	}
	return context;
};
